import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "./assets/styles/style.css";
import { initTheme } from "./composables/useTheme.js";

initTheme();

const app = createApp(App);

app.use(store).use(router);

app.config.errorHandler = (err, instance, info) => {
  if (process.env.NODE_ENV !== "production") {
    console.error("Erreur Vue :", err, info);
  }
};

router.isReady().then(() => app.mount("#app"));
